var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135.87 192.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.37,8.78C62.91,2,43.35-4,26.59,3.44,15.82,8.12,2.51,20.2.21,50.77c-2,25.56,10,48.89,34.51,67.55a152,152,0,0,0,33.36,18.81L74,139.35h.08l4.69-5.92C116.49,69.18,90.68,23.9,71.37,8.78Zm.49,121.94c-13-5.09-68.12-29.83-64.42-79.46C9,30,16.64,15.68,29.46,10.09a34.82,34.82,0,0,1,14-2.79c9.7,0,18.82,3.53,23.5,7.15C84.52,28.34,107.86,70.24,71.86,130.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.23,184.91l-3.4-6.42c21.75-11.49,37.34-29.65,37.5-29.83l5.54,4.71c-.67.78-16.6,19.39-39.64,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.49,171.14,88,164.77c19.52-10.66,33.52-27.52,33.66-27.69l5.62,4.62c-.6.74-15,18.09-35.81,29.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.86,157.6l-3.69-6.27c14.93-8.78,25.64-22.72,25.75-22.86l5.78,4.41c-.46.61-11.65,15.18-27.84,24.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,192.34A150.27,150.27,0,0,1,20.4,178.77l3.35-6.46c.21.11,21.56,11,46,13.4l-.71,7.23q-2.55-.24-5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.3,179.36A137.14,137.14,0,0,1,26.46,166.9l3.35-6.45c.2.1,19.73,10.1,41.82,12.23L71,179.91c-1.57-.15-3.13-.33-4.65-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.34,166.83a108.62,108.62,0,0,1-33.58-11.12l3.51-6.37c.15.09,15.61,8.46,32.78,10.52l-.84,7.21c-.62-.07-1.25-.15-1.87-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.07,39.55A15.42,15.42,0,1,1,55.66,24.13,15.41,15.41,0,0,1,71.07,39.55Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.9848a123683ed998863d486b3fb918a0.svg";
export { ForwardRef as ReactComponent };